const TipoPerfilEnum = {
  Nenhum: 0,
  Sistema: 1,
  Administrador: 2,
  Comum: 3
};

export default TipoPerfilEnum;
